import React, { useState } from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import { FiCalendar, FiChevronDown, FiChevronRight } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import {
  Label,
  MenuElement,
  MenuList,
} from '../../../../../components/Template/Sidebar'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import Badge from '../../../../../components/Template/Badge'
import { getReservationsListNew } from '../../../../../reducers/reservationsList/selectors'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import {
  getUserId,
  getUserPriceGroup,
} from '../../../../../reducers/userAccount/selectors/userAccount'
import useIsScope from '../../../../../hooks/useIsScope'
import { PermissionScope } from '../../../../Employees'
import {
  isInPlanScope,
  isInPlanScopeRedirect,
  PlansScope,
  useLicensePlansScope,
} from '../index'
import Flex from 'typescript-styled-flex'
import DisabledIcon from '../../../../../assets/disabled.png'
import Popover from '@material-ui/core/Popover'
import { UpgradePremiumPopover } from '../../../../../screens/UpgradePremium/UpgradePremium'
import { PopoveredIcon2 } from '../../../../../components/PopoveredIcon/PopoveredIcon'
import { useMediaQuery, useTheme } from '@material-ui/core'
import SmartLink from '../../../../../components/Template/Sidebar/SmartLink'
import UpgradePremiumBlockScreenModal from '../../../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'

function Booking({
  isSidebarOpen,
  className,
  size = 1,
}: IBookingProps & IWithSize & WithTranslation) {
  const [isOpen, toggleOpen] = React.useState(false)
  const userId = useSelector(getUserId)
  const userPriceGroup = useSelector(getUserPriceGroup)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const [isModalOpened, setIsModalOpened] = useState(false)
  // const [disablePopoverUntilMouseLeave, setDisablePopoverUntilMouseLeave] = useState(false)


  const handleLinkClick = (event, userPlanScope) => {
    if (
      userPlanScope &&
      isMobile &&
      isInPlanScope(planScope, userPlanScope, userPriceGroup) === true
    ) {
      event.preventDefault()
      event.stopPropagation()
      setIsModalOpened(true)
    } else if (
      userPlanScope &&
      !isMobile &&
      isInPlanScope(planScope, userPlanScope, userPriceGroup) === true
    ) {
      handlePopoverOpen(event)
    }
  }

  const handlePopoverOpen = event => {
    // if (disablePopoverUntilMouseLeave) return
    event.preventDefault()
    event.stopPropagation()
    setPopoverAnchor(event.currentTarget)
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
    // setDisablePopoverUntilMouseLeave(true)
  }

  // const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
  //   const target = event.currentTarget
  //   if (isSidebarOpen) {
  //     setTimeout(() => {
  //       setPopoverAnchor(target)
  //     }, 50)
  //   }
  // }

  function toggleIsOpen() {
    toggleOpen(!isOpen)
  }

  const planScope = useLicensePlansScope()

  const scopes = useIsScope({
    reservationList: [PermissionScope.SCOPE_CAN_VIEW_LIST_RESERVATIONS],
    clients: [PermissionScope.SCOPE_CAN_USE_LIST_CLIENTS],
    messages: [PermissionScope.SCOPE_CAN_USE_TEMPLATES],
  })

  const eventsCount = useSelector(getReservationsListNew).length

  // const trackClick = () => {
  //   Mixpanel.people.increment(userId, 'Export Menu Opened', 1)
  //   Mixpanel.track('Main Menu Export Item Used', {})
  // }

  const trackClick2 = () => {
    Mixpanel.people.increment(userId, 'Clients Menu Opened', 1)
    Mixpanel.track('Clients Menu Item Used', {})
  }

  // const trackClick3 = () => {
  //   Mixpanel.people.increment(userId, 'Message Templates Menu Opened', 1)
  //   Mixpanel.track('Message Templates Menu Item Used', {})
  // }

  return (
    <>
      <MenuElement
        size={size}
        alignCenter={true}
        primary={true}
        column={true}
        open={isOpen}
        active={isOpen}
      >
        <MenuElement
          size={size}
          as={'div'}
          alignCenter={true}
          open={isOpen}
          onClick={toggleIsOpen}
          className={`${className}-button-expand`}
          nested={true}
        >
          <b>
            <FiCalendar size={16 * size} />
          </b>
          <Label primary={true} size={size} className={`${className}-label`}>
            <Trans i18nKey={'menu_reservations'}>Rezerwacje</Trans>
          </Label>
          <b>
            {isSidebarOpen &&
              (isOpen ? (
                <FiChevronDown size={14 * size} />
              ) : (
                <FiChevronRight size={14 * size} />
              ))}
          </b>
        </MenuElement>
        {isSidebarOpen && (
          <MenuList
            nested={true}
            size={size}
            style={{ maxHeight: 'var(--full)' }}
          >
            <SmartLink
              size={size}
              to={'/booking/calendar'}
              onClick={e => {
                handleLinkClick(e, undefined)
              }}
              activeClassName={'active'}
              nested={true}
              className={`${className}-item-0-label`}
            >
              <MenuElement
                size={size}
                alignCenter={true}
                className={`${className}-item-0-button`}
              >
                <Trans i18nKey={'z677_calendar'}>Kalendarz</Trans>
              </MenuElement>
            </SmartLink>
            {scopes.reservationList && (
              <SmartLink
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.ReservationList,
                  '/booking/reservations',
                  userPriceGroup,
                )}
                activeClassName={'active'}
                nested={true}
                className={`${className}-item-1-label`}
                onClick={e => {
                  const shouldBlock = isInPlanScope(
                    planScope,
                    PlansScope.ReservationList,
                    userPriceGroup,
                  )

                  if (shouldBlock) {
                    e.preventDefault()
                    e.stopPropagation()
                    if (isMobile) setIsModalOpened(true)
                    else handlePopoverOpen(e)
                    return
                  }

                  Mixpanel.track('Reservation List Menu Item Used', {})
                  Mixpanel.people.increment(userId, 'Reservations Menu Opened', 1)
                }}
              >
                <MenuElement
                  // onMouseEnter={!isMobile && isInPlanScope(planScope, PlansScope.ReservationList, userPriceGroup) ? handleMouseEnter: undefined}
                  size={size}
                  alignCenter={true}
                  className={`${className}-item-1-button`}
                >
                  <Flex alignCenter={true} full={true}>
                    <Trans i18nKey={'menu_calendar_list'}>
                      Lista Rezerwacji
                    </Trans>
                    {!isInPlanScope(
                      planScope,
                      PlansScope.ReservationList,
                      userPriceGroup,
                    ) && (
                      <Flex style={{ marginLeft: 'auto' }}>
                        <Badge
                          size={size}
                          className={`${className}-badge`}
                          primary={!!eventsCount}
                        >
                          {eventsCount}
                        </Badge>
                      </Flex>
                    )}
                    {isInPlanScope(
                      planScope,
                      PlansScope.ReservationList,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter={true}
                        justifyEnd={true}
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}
            {/*<Link*/}
            {/*  size={size}*/}
            {/*  to={'/booking/notifications'}*/}
            {/*  activeClassName={'active'}*/}
            {/*  nested={true}*/}
            {/*  className={`${className}-item-4-label`}*/}
            {/*>*/}
            {/*  <MenuElement*/}
            {/*    size={size}*/}
            {/*    alignCenter={true}*/}
            {/*    className={`${className}-item-4-button`}*/}
            {/*  >*/}
            {/*    <Trans i18nKey={'room_notification_title'}>Powiadomienia</Trans>*/}
            {/*  </MenuElement>*/}
            {/*</Link>*/}
            {scopes.clients && (
              <SmartLink
                size={size}
                onClick={e => {
                  trackClick2()
                  handleLinkClick(e, PlansScope.Clients)
                }}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.Clients,
                  '/clients',
                  userPriceGroup,
                )}
                activeClassName={'active'}
                nested={true}
                className={`${className}-item-4-label`}
              >
                <MenuElement
                  // onMouseEnter={!isMobile && isInPlanScope(planScope, PlansScope.Clients, userPriceGroup) ? handleMouseEnter: undefined}
                  size={size}
                  alignCenter={true}
                  className={`${className}-item-4-button`}
                >
                  <Flex alignCenter={true} full={true}>
                    <Trans i18nKey={'menu_clients'}>Klienci</Trans>
                    {isInPlanScope(
                      planScope,
                      PlansScope.Clients,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter={true}
                        justifyEnd={true}
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}
            {scopes.messages && (
              <SmartLink
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.MessageTemplates,
                  '/templates',
                  userPriceGroup,
                )}
                activeClassName={'active'}
                nested={true}
                onClick={e => handleLinkClick(e, PlansScope.MessageTemplates)}
                className={`${className}-item-4-label`}
              >
                <MenuElement
                  // onMouseEnter={!isMobile && isInPlanScope(planScope, PlansScope.MessageTemplates, userPriceGroup) ? handleMouseEnter: undefined}
                  size={size}
                  alignCenter={true}
                  className={`${className}-item-4-button`}
                >
                  <Flex alignCenter={true} full={true}>
                    <Trans i18nKey={'custom_messages_title'}>
                      Szablony Wiadomości
                    </Trans>
                    {isInPlanScope(
                      planScope,
                      PlansScope.MessageTemplates,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter={true}
                        justifyEnd={true}
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}
            {/*<Link*/}
            {/*  onClick={trackClick}*/}
            {/*  size={size}*/}
            {/*  to={'/booking/export'}*/}
            {/*  activeClassName={'active'}*/}
            {/*  nested={true}*/}
            {/*  className={`${className}-item-5-label`}*/}
            {/*>*/}
            {/*  <MenuElement*/}
            {/*    size={size}*/}
            {/*    alignCenter={true}*/}
            {/*    className={`${className}-item-5-button`}*/}
            {/*  >*/}
            {/*    <Trans i18nKey={'menu_export'}>Eksport</Trans>*/}
            {/*  </MenuElement>*/}
            {/*</Link>*/}
          </MenuList>
        )}
      </MenuElement>
      <Flex
        style={{ marginLeft: 'auto' }}
        alignCenter={true}
        justifyEnd={true}
      >
        <PopoveredIcon2
          withIcon={false}
          anchorEl={popoverAnchor}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          onOpen={handlePopoverOpen}
          onClose={handlePopoverClose}
        />
      </Flex>
      <UpgradePremiumBlockScreenModal
        open={isModalOpened}
        close={() => setIsModalOpened(false)}
      />
    </>
  )
}

export const PopoveredIcon = () => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const handlePopoverOpen = event => {
    event.preventDefault()
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  return (
    <>
      <img
        onMouseEnter={handlePopoverOpen}
        // onMouseLeave={handlePopoverClose}
        src={DisabledIcon}
        alt={'templates'}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
      >
        <UpgradePremiumPopover handleClose={handlePopoverClose} />
      </Popover>
    </>
  )
}

export default Booking

export interface IBookingProps {
  count: number
  isSidebarOpen: boolean
  className?: string
}
